// CardShopComponent.jsx
import React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {CardShopStructList} from "../structs/CardShopStructList";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import {Snackbar} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Typography from "@mui/material/Typography";
import {BackButton, BottomMenu} from "./HookUtils";
import {Link} from "react-router-dom";
import Location from "../assets/icons/location.svg";
import EmptyShopCard from "../assets/icons/empty_shopcard.jpg";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AvatarRound from "../assets/icons/avatar_round.svg";
import {safeAdd, safeMultiply} from "./mathUtils";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Zoom2 from "@mui/material/Zoom";
import Swal from "sweetalert2";
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import {PrintUtils} from "../utils/PrintUtils";
/* =========================
   ✅ Helpers (NO replace on number)
   ========================= */
const n = (v) => {
    const x = Number(v);
    return Number.isFinite(x) ? x : 0;
};
const priceTextFa = (v) => n(v).toLocaleString("fa-IR");

// ✅ unique key for cart row (backward compatible)
// - old products: product.id
// - variant products: product.id + "::" + variant_id
const cartKeyOf = (product) => {
    const pid = product?.id != null ? String(product.id) : "";
    const vid = product?.variant_id != null ? String(product.variant_id) : "";
    return vid ? `${pid}::${vid}` : pid;
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


// constants

export class CardShopComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            cardShopList: [],
            totalOrder: 0,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            userData: null,
            units: props.units_prop || [],
            name: "",
            address: "",
            // --- New POS States ---
            allPosData: {},
            posDevices: [],
            selectedAccountId: null, // Note: You need to set this when the user selects an account in your UI
        };

    }
    componentDidMount() {
        this.getCardShop();
        this.getUserData();

        this.renderPosButton()
    }

    renderPosButton() {
        // 1. Read POS data from localStorage
        const posDataStr = localStorage.getItem('allPosData');
        if (posDataStr) {
            try {
                const allPosData = JSON.parse(posDataStr);

                // If allPosData is an object grouped by IDs, this flattens it into one array of devices
                // If it's already an array, it remains an array.
                const allDevicesArray = Array.isArray(allPosData)
                    ? allPosData
                    : Object.values(allPosData).flat();

                this.setState({
                    allPosData: allPosData,
                    posDevices: allDevicesArray // Set directly without filtering
                });

            } catch (error) {
                console.error("Error parsing POS data:", error);
            }
        }
    }
    // ==========================================
    // Loading Dialog Helpers
    // ==========================================
    showLoadingDialog(message = 'لطفا صبر کنید...') {
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                title: message,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }
    }

    hideLoadingDialog() {
        // Only close if the current Swal is a loading dialog
        if (typeof Swal !== 'undefined' && Swal.isLoading()) {
            Swal.close();
        }
    }

    // ==========================================
    // Core Methods
    // ==========================================


    sendToPos = async (ip = null) => {
        try {
            this.showLoadingDialog('در حال ثبت سفارش...');

            /** ----------------------------------
             * STEP 1 – CREATE ORDER (PENDING)
             * ---------------------------------- */
            const result = this.getProductsAndCounts();
            if (!result) {
                this.hideLoadingDialog();
                return;
            }

            const {products, counts} = result;

            const orderRes = await fetch(BASE_URL_API + "order", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("pwa_token")
                },
                body: JSON.stringify({
                    payment_type: "pos",
                    products: products.toString(),
                    counts: counts.toString(),
                    user_agent: "pwa",
                    table_id: this.props.table_id ?? null,
                    ...(localStorage.getItem("bank_account") && { bank_account_id: localStorage.getItem("bank_account") })
                })
            });

            const orderJson = await orderRes.json();

            if (!orderRes.ok || !orderJson.transactions?.length) {
                Swal.fire({
                    icon: "error",
                    title: "خطا",
                    text: "خطا در ثبت سفارش. مجددا امتحان کنید."
                });
                return;
            }

            const transactionId = orderJson.transactions[0];

            /** ----------------------------------
             * STEP 2 – SEND AMOUNT TO POS DEVICE
             * ---------------------------------- */
            this.showLoadingDialog('لطفا کارت بکشید... (منتظر تراکنش کارتخوان)');

            const rialAmount = Math.round(this.state.totalOrder * 10);

            const payload = {
                amount: String(rialAmount),
                pos_ip: ip,
                invoice: "INV-" + Date.now()
            };

            const posRes = await fetch("http://localhost:9090/pos/sale", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!posRes.ok) {
                Swal.fire({
                    icon: "error",
                    title: "خطا",
                    text: "ارتباط با کارتخوان برقرار نشد مجددا امتحان کنید😨"
                });
                return;
            }

            const posJson = await posRes.json();
            console.log("✅ POS Response:", posJson);

            /** ----------------------------------
             * STEP 3 – PARSE RAW POS DATA
             * ---------------------------------- */
            let rawData = {};

            if (posJson.raw && posJson.raw.includes("=")) {
                posJson.raw.split(/\r?\n/).forEach(line => {
                    const [k, v] = line.split("=");
                    if (k && v) rawData[k.trim()] = v.trim();
                });
            }

            const rf = posJson.rawFields || {};

            if (!rawData.TraceID && rf.TraceID) rawData.TraceID = rf.TraceID;
            if (!rawData.TerminalID && rf.TN) rawData.TerminalID = rf.TN;
            if (!rawData.RRN && rf.RN) rawData.RRN = rf.RN;

            if (!rawData.Date && rf.DT) {
                const dt = String(rf.DT);
                if (dt.length === 14) {
                    rawData.Date = `${dt.slice(0,4)}/${dt.slice(4,6)}/${dt.slice(6,8)}`;
                    rawData.Time = `${dt.slice(8,10)}:${dt.slice(10,12)}:${dt.slice(12,14)}`;
                } else if (dt.includes("-")) {
                    const parts = dt.split("-");
                    if (parts.length === 2) {
                        rawData.Date = parts[0];
                        rawData.Time = parts[1];
                    }
                }
            }

            /** ----------------------------------
             * STEP 4 – VALIDATE POS RESPONSE
             * ---------------------------------- */
            const isSuccess = posJson.code === "00" || posJson.code === 0 || posJson.ok === true;

            if (!isSuccess) {
                Swal.fire({
                    icon: "warning",
                    title: "هشدار",
                    text: "پرداخت لغو شد"
                });
                return;
            }

            /** ----------------------------------
             * STEP 5 – NORMALIZE DATA
             * ---------------------------------- */
            const rrn = posJson.rrn || rawData.RRN || rf.RN || "";
            const traceId = posJson.traceId || rawData.TraceID || rf.TraceID || "";
            const terminalId = posJson.terminalId || rawData.TerminalID || rf.TN || "";
            const date = posJson.date || rawData.Date || "";
            const time = posJson.time || rawData.Time || "";

            /** ----------------------------------
             * STEP 6 – CONFIRM POS PAYMENT
             * ---------------------------------- */
            this.showLoadingDialog('پرداخت موفق. در حال تایید نهایی سفارش...');

            const confirmRes = await fetch(
                BASE_URL_API + `confirm-pos?table_id=${this.props.table_id}`,
                {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("pwa_token")
                    },
                    body: JSON.stringify({
                        transaction_id: transactionId,
                        amount: rialAmount,
                        meta: {
                            rrn: rrn,
                            traceId: traceId,
                            cardNo: posJson.cardMasked || "",
                            terminalId: terminalId,
                            responseCode: posJson.code,
                            invoiceId: posJson.invoice || "INV-" + traceId,
                            date: date,
                            time: time,
                            raw: posJson
                        }
                    })
                }
            );

            const confirmJson = await confirmRes.json();
            console.log("✅ Confirm Response:", confirmJson);

            if (!confirmRes.ok) {
                Swal.fire({
                    icon: "error",
                    title: "خطا",
                    text: confirmJson.message || "تایید پرداخت ناموفق بود"
                });
                return;
            }

            /** ----------------------------------
             * ✅ DONE - PRINT AND REDIRECT
             * ---------------------------------- */

            // 1. Trigger the silent print BEFORE redirecting
            // handleSilentPrint will show its own loading dialog
            await PrintUtils.handleSilentPrint(confirmJson.data);

            Swal.fire({
                icon: "success",
                title: "موفق",
                text: "ممنون از خریدت دوست خوبم ❤️ رسیدتو حتما همراه داشته باش.\n سفارشت رو داریم حاضر میکنیم 🏃. \nبزودی از طریق پیجر صدات میزنم.\n نوش جان 😋",
                allowOutsideClick: false, // جلوگیری از بسته شدن با کلیک بیرون کادر
                allowEscapeKey: false     // جلوگیری از بسته شدن با دکمه Esc
            }).then((result) => {
                if (result.isConfirmed) {
                    CardShopRepository.deleteAll();

                    if (confirmJson.redirect_url) {
                        window.location.replace(confirmJson.redirect_url);
                    }
                }
            });

        } catch (err) {
            console.error("POS FLOW ERROR:", err);
            Swal.fire({
                icon: "error",
                title: "خطا",
                text: "خطایی رخ داد. دوباره امتحان کن لطفا"
            });
        } finally {
            // Guarantee loading dialog goes away if error occurred before a specific Swal was shown
            this.hideLoadingDialog();
        }
    };


    // 2. Filter POS devices based on the selected bank account
    // 3. The function that connects to localhost:9090
    // sendToPos = async (ip = null) => {
    //
    //     try {
    //
    //         const result = this.getProductsAndCounts();
    //
    //         if (!result) return;
    //
    //         const { products, counts } = result;
    //
    //         // Send the successful POS details to your backend order route
    //         const backendRes = await fetch(BASE_URL_API + "order", {
    //             method: "POST",
    //             headers: {
    //                 "Accept": "application/json",
    //                 "Content-Type": "application/json",
    //                 "Authorization": "Bearer " +localStorage.getItem('pwa_token') // Assuming you use JWT token in localStorage
    //             },
    //             body: JSON.stringify({
    //                 payment_type: 'pos', // Tells OrderController to skip Shaparak
    //                 products: products.toString(),
    //                 counts: counts.toString(),
    //                 user_agent: "pwa",
    //                 table_id: this.props.table_id ?? null,
    //                 meta: {
    //                     responseCode: "00",
    //                     amount: "موفق",
    //                     cardNo: "621986**9621",
    //                     rrn: "748039596925",
    //                     traceId: "825624",
    //                     invoiceId: "1760428018611",
    //                     terminalId: "45294293",
    //                     date: "1404/07/22",
    //                     time: "11:08:33",
    //                     bank_account_id: "10"
    //                 }
    //             })
    //         });
    //         const backendJson = await backendRes.json();
    //         if (backendRes.ok) {
    //             alert("پرداخت با دستگاه پوز با موفقیت انجام شد و سفارش ثبت گردید.");
    //             // Redirect user to orders page or refresh to clear cart
    //             window.location.reload();
    //         } else {
    //             alert("پرداخت انجام شد اما ثبت سفارش در سرور با خطا مواجه شد.");
    //             console.error("Backend Error:", backendJson);
    //         }
    //     } catch (backendError) {
    //         alert("خطا در ارتباط با سرور پس از پرداخت.");
    //         console.error("Backend Catch Error:", backendError);
    //     }
    //
    //
    //     // // Calculate the total amount to send to the POS
    //     // const amount = Math.floor(
    //     //     this.state.totalOrder +
    //     //     this.state.cardShopList.reduce((sum) => sum, 0)
    //     // );
    //     //
    //     // console.log(`Sending ${amount} to POS IP: ${ip || 'Default IP'}`);
    //     //
    //     // // Construct payload mimicking the sendPosPaymentRest structure
    //     // const payload = {
    //     //     amount: String(amount * 10),
    //     //     pos_ip: ip,
    //     //     invoice: String("INV-" + Date.now())
    //     // };
    //     //
    //     // try {
    //     //     const res = await fetch("http://localhost:9090/pos/sale", {
    //     //         method: "POST",
    //     //         headers: {
    //     //             "Accept": "application/json",
    //     //             "Content-Type": "application/json"
    //     //         },
    //     //         body: JSON.stringify(payload)
    //     //     });
    //     //
    //     //     if (!res.ok) {
    //     //         const text = await res.text();
    //     //         throw new Error("POS error " + res.status + ": " + text);
    //     //     }
    //     //
    //     //     const json = await res.json();
    //     //     console.log("✅ POS REST Response:", json);
    //     //
    //     //     // 🔹 parse raw but DON'T change main structure
    //     //     let rawFields = {};
    //     //     if (json.raw && typeof json.raw === "string" && json.raw.includes("=")) {
    //     //         json.raw.split(/\r?\n/).forEach(line => {
    //     //             const [k, v] = line.split("=");
    //     //             if (k && v) rawFields[k.trim()] = v.trim();
    //     //         });
    //     //
    //     //         // optional helpers
    //     //         if (!json.code && rawFields.ResponseCode)
    //     //             json.code = rawFields.ResponseCode;
    //     //
    //     //         if (!json.rrn && rawFields.RRN)
    //     //             json.rrn = rawFields.RRN;
    //     //
    //     //         if (!json.cardMasked && rawFields.PAN)
    //     //             json.cardMasked = rawFields.PAN;
    //     //     }
    //     //
    //     //     // just add rawFields, keep everything else as-is
    //     //     json.rawFields = rawFields;
    //     //
    //     //     // ✅ HANDLE SUCCESS AND CALL BACKEND
    //     //     // "00" usually means success in ISO8583 banking standard
    //     //     if (json.code === "00" || json.code === 0) {
    //     //
    //     //
    //     //     } else {
    //     //         // POS Payment Failed or Cancelled
    //     //         alert("عملیات پرداخت لغو شد یا با خطا مواجه گردید. کد خطا: " + json.code);
    //     //     }
    //     //
    //     //     return json;
    //     //
    //     // } catch (err) {
    //     //     console.error("❌ POS REST fetch error:", err);
    //     //     alert("خطا در ارتباط با نرم‌افزار واسط پوز (Localhost:9090). لطفا بررسی کنید برنامه باز باشد.");
    //     //     throw err;
    //     // }
    // };

    getUserData() {
        fetch(BASE_URL_API + "user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then(
                (results) => {
                    if (results.code === "200" || results.code === 200) {
                        this.setState({
                            userData: results.data,
                            name: results.data?.name || "",
                            address: results.data?.address || "",
                        });
                    }
                },
                () => {
                    console.log("error");
                }
            );
    }

    /* =========================
       ✅ totals & grouping (variant-safe)
       ========================= */
    getCardShop() {
        const all = CardShopRepository.getAll();
        if (!all) {
            this.setState({cardShopList: [], totalOrder: 0});
            return;
        }

        let cardShopList = [];

        all.forEach(function (row) {
            let check = false;

            cardShopList.forEach(function (marketBucket) {
                if (row?.product?.markets?.id === marketBucket?.market?.id) {
                    const unitPrice = n(row.product.price) - n(row.product.del_price);
                    if (unitPrice > 0) {
                        marketBucket.total = safeAdd(
                            marketBucket.total,
                            safeMultiply(n(row.count), unitPrice, 6),
                            6
                        );
                    }
                    marketBucket.productList.push(row);
                    check = true;
                }
            });

            if (!check) {
                let cardShopStructList = new CardShopStructList();
                cardShopStructList.market = row.product.markets;
                cardShopStructList.total = 0;
                cardShopStructList.productList = [];

                const unitPrice = n(row.product.price) - n(row.product.del_price);
                if (unitPrice > 0) {
                    cardShopStructList.total = safeAdd(
                        cardShopStructList.total,
                        safeMultiply(n(row.count), unitPrice, 6),
                        6
                    );
                }

                cardShopStructList.productList.push(row);
                cardShopList.push(cardShopStructList);
            }
        });

        // total of all markets
        let sum = 0;
        cardShopList.forEach(function (m) {
            sum = safeAdd(sum, n(m.total), 6);
        });

        this.setState({
            cardShopList,
            totalOrder: Math.floor(sum),
        });
    }

    getProductsAndCounts() {
        const list = CardShopRepository.getAll();

        if (!this.state.name) {
            this.setState({
                openSnackbar: true,
                message: "ابتدا نام و نام خانوادگی را تکمیل کنید!",
                snackbarType: "error",
            });
            return null;
        }

        if (!this.state.address) {
            this.setState({
                openSnackbar: true,
                message: "ابتدا آدرس خودرا از منوی پروفایل تکمیل کنید!",
                snackbarType: "error",
            });
            return null;
        }

        if (!list || !list.length) {
            return null;
        }

        let products = list[0].product.id;
        let counts = list[0].count;

        if (list.length > 1) {
            for (let i = 1; i < list.length; i++) {
                products += "," + list[i].product.id;
                counts += "," + list[i].count;
            }
        }

        return {products, counts};
    }

    render() {
        const handleCloseSnackbar = () => {
            this.setState({openSnackbar: false});
        };

        const MAX_LENGTH = 50;

        const onPaymentCLicked = () => {

            const result = this.getProductsAndCounts();

            if (!result) return;

            const {products, counts} = result;

            fetch(BASE_URL_API + "order", {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    products: products.toString(),
                    counts: counts.toString(),
                    user_agent: "pwa",
                    payment_type: "online" // Explicitly tell backend this is an online gateway order
                }),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.code === 200) {
                        this.setState({
                            openSnackbar: true,
                            message: "در حال انتقال به درگاه پرداخت...",
                            snackbarType: "success",
                        });
                        redirectToSepehr(result);
                    } else {
                        this.setState({
                            openSnackbar: true,
                            message: result.message,
                            snackbarType: "error",
                        });
                    }
                });
        };

        const redirectToSepehr = (data) => {
            const form = document.createElement("form");
            form.method = "POST";
            form.action = data.redirect_url;

            const fields = {
                TerminalID: data.merchant_id,
                token: data.token,
                getMethod: "1",
            };

            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
        };

        return (
            <React.Fragment>
                <AppBar
                    style={{
                        background: "rgba(238,238,238,0.3)",
                        overflow: "auto",
                        display: "flex",
                    }}
                >
                    <ToolbarMui>
                        <ShoppingBasketOutlinedIcon style={{color: "black"}}/>
                        <ListItemText align="center">
                            <strong
                                style={{
                                    fontSize: 18,
                                    overflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: "black",
                                }}
                            >
                                {"سبد خرید"}
                            </strong>
                        </ListItemText>
                        <BackButton/>
                    </ToolbarMui>
                </AppBar>

                {this.state.userData !== null ? (
                    <div
                        style={{background: "#f5f5f5", marginTop: 65, padding: 32}}
                        alignItems="center"
                        justifyContent="center"
                        align="center"
                    >
                        <div style={{display: "flex"}}>
                            <img
                                style={{width: 28, height: 28, marginTop: 8}}
                                alt="avatar2"
                                src={AvatarRound}
                            />

                            <Typography
                                style={{
                                    overflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: "black",
                                    fontWeight: "bold",
                                    flex: 12,
                                }}
                                align="right"
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        overflow: "ellipsis",
                                        paddingRight: 8,
                                        color: "black",
                                    }}
                                >
                                    {"نام و نام خانوادگی: ‌" + (this.state.userData?.name || "")}
                                </p>
                            </Typography>

                            {!this.props.table_id && <IconButton component={Link} to={"/profile"} size="large">
                                <BorderColorIcon style={{color: "black"}}/>
                            </IconButton>}


                        </div>

                        <div style={{display: "flex"}}>
                            <img
                                style={{width: 24, height: 24, marginTop: 8}}
                                alt="avatar2"
                                src={Location}
                            />

                            <Typography
                                style={{
                                    overflow: "ellipsis",
                                    whiteSpace: "pre-line",
                                    wordWrap: "break-word",
                                    color: "black",
                                    fontWeight: "bold",
                                    flex: 12,
                                }}
                                align="right"
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        paddingRight: 8,
                                        color: "black",
                                    }}
                                >
                                    {"ارسال به: ‌" + (this.state.userData?.address || "")}
                                </p>
                            </Typography>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {this.state.cardShopList === null ||
                this.state.cardShopList.length === 0 ? (
                    <div align="center">
                        <img style={{width: "20%"}} alt="avatar2" src={EmptyShopCard}/>
                    </div>
                ) : (
                    ""
                )}

                <List>
                    {this.state.cardShopList.map((marketBucket, idxMarket) => (
                        <ListItem
                            key={marketBucket?.market?.id || idxMarket}
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div style={{maxWidth: 500}}>
                                <Paper>
                                    <ListItemText style={{align: "right"}}>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <p
                                                    style={{
                                                        marginRight: 12,
                                                        overflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        color: "green",
                                                        fontWeight: "bold",
                                                    }}
                                                    align="right"
                                                >
                                                    {marketBucket.market?.name}
                                                </p>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <p
                                                    style={{
                                                        textOverflow: "ellipsis",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        color: "gray",
                                                        fontSize: 12,
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {`هزینه ارسال: ${"پس کرایه"}`}
                                                </p>
                                            </Grid>

                                            {(marketBucket.productList || []).map((row, idxRow) => {
                                                const product = row?.product || {};
                                                const key = cartKeyOf(product) || `${idxMarket}-${idxRow}`;

                                                const unitPrice = n(product.price) - n(product.del_price);
                                                const qty = n(row?.count);
                                                const lineTotal =
                                                    unitPrice > 0 ? safeMultiply(qty, unitPrice, 6) : 0;

                                                const title = product?.title || "";
                                                const showTitle =
                                                    title.length > MAX_LENGTH
                                                        ? `${title.substring(0, MAX_LENGTH)}...`
                                                        : title;

                                                const unitsCache =
                                                    JSON.parse(
                                                        localStorage.getItem("productUnitsCache")
                                                    ) || [];
                                                const selectedUnit = unitsCache.find(
                                                    (u) => u.id === product.unit_id
                                                );
                                                const dataType = selectedUnit?.data_type;

                                                return (
                                                    <React.Fragment key={key}>
                                                        <Grid item xs={2}>
                                                            <Paper
                                                                style={{
                                                                    width: 45,
                                                                    height: 45,
                                                                    marginRight: 15,
                                                                    marginBottom: 15,
                                                                    align: "center",
                                                                    backgroundPosition: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: 45,
                                                                        height: 45,
                                                                        objectFit: "cover",
                                                                    }}
                                                                    alt=""
                                                                    src={
                                                                        product?.pictures?.length > 0
                                                                            ? PRODUCT_BASE_URL_API +
                                                                            product.pictures[0].url
                                                                            : "hamekara-logo.png"
                                                                    }
                                                                />
                                                            </Paper>

                                                            {/* ✅ FIXED: no replace() */}
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    color: "gray",
                                                                    marginRight: 15,
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {"قیمت: " + priceTextFa(product.price) + " تومان"}
                                                            </p>

                                                            {/* ✅ show variant title small if exists */}
                                                            {product?.variant && (
                                                                <p
                                                                    style={{
                                                                        overflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        color: "#666",
                                                                        marginRight: 15,
                                                                        fontSize: 11,
                                                                    }}
                                                                >
                                                                    {product?.variant?.title
                                                                        ? `تنوع: ${product.variant.title}`
                                                                        : ""}
                                                                </p>
                                                            )}
                                                        </Grid>

                                                        <Grid item xs={4}>
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "pre-line",
                                                                    wordWrap: "break-word",
                                                                    fontSize: 12,
                                                                }}
                                                                align="center"
                                                            >
                                                                {showTitle}
                                                            </p>
                                                        </Grid>

                                                        <Grid item xs={2}>
                                                            <p
                                                                style={{
                                                                    overflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    fontSize: 12,
                                                                }}
                                                                align="center"
                                                            >
                                                                {selectedUnit
                                                                    ? `${selectedUnit.unit_type} ${row.count} ${selectedUnit.name}`
                                                                    : `${row.count}`}
                                                            </p>
                                                        </Grid>

                                                        {n(product.price) > 0 ? (
                                                            <Grid item xs={4}>
                                                                <p
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        fontSize: 12,
                                                                    }}
                                                                    align="center"
                                                                >
                                                                    {"مجموع: " +
                                                                        priceTextFa(Math.floor(n(lineTotal))) +
                                                                        " تومان"}
                                                                </p>
                                                            </Grid>
                                                        ) : (
                                                            <Grid item xs={3}>
                                                                <p
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        fontSize: 12,
                                                                    }}
                                                                    align="center"
                                                                >
                                                                    {" تماس بگیرید "}
                                                                </p>
                                                            </Grid>
                                                        )}

                                                        {/* Controls */}
                                                        <Grid
                                                            item
                                                            xs={20}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "8px",
                                                                marginTop: "8px",
                                                            }}
                                                        >
                                                            {/* Decrease */}
                                                            <IconButton
                                                                color="inherit"
                                                                aria-label="decrease"
                                                                edge="end"
                                                                onClick={() => {
                                                                    if (!row?.product) return;

                                                                    const numResult = (
                                                                        parseFloat(row.count) - 1
                                                                    ).toFixed(3);
                                                                    const result = parseFloat(numResult);
                                                                    const newCount = Math.max(0, result);

                                                                    // ✅ variant-safe remove:
                                                                    if (newCount === 0) {
                                                                        // remove by key (productId + variantId)
                                                                        CardShopRepository.removeItemByKey(key);

                                                                        // update UI list
                                                                        this.setState((prev) => {
                                                                            const updatedList = (prev.cardShopList || [])
                                                                                .map((m) => ({
                                                                                    ...m,
                                                                                    productList: (m.productList || []).filter(
                                                                                        (p) =>
                                                                                            cartKeyOf(p?.product) !== key
                                                                                    ),
                                                                                }))
                                                                                .filter((m) => (m.productList || []).length > 0);

                                                                            // recompute total
                                                                            const totalOrder = updatedList.reduce(
                                                                                (sumMarket, m) => {
                                                                                    const mt = (m.productList || []).reduce(
                                                                                        (sumProduct, p) => {
                                                                                            const pr =
                                                                                                n(p?.product?.price) -
                                                                                                n(p?.product?.del_price);
                                                                                            const q = n(p?.count);
                                                                                            const lt = safeMultiply(
                                                                                                q,
                                                                                                pr > 0 ? pr : 0,
                                                                                                6
                                                                                            );
                                                                                            return safeAdd(sumProduct, lt, 6);
                                                                                        },
                                                                                        0
                                                                                    );
                                                                                    return safeAdd(sumMarket, mt, 6);
                                                                                },
                                                                                0
                                                                            );

                                                                            return {
                                                                                cardShopList: updatedList,
                                                                                totalOrder: Math.floor(n(totalOrder)),
                                                                            };
                                                                        });

                                                                        return;
                                                                    }

                                                                    // update repo count
                                                                    CardShopRepository.updateCountByKey(key, row.product, newCount);
                                                                    row.count = newCount;

                                                                    // recompute total
                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({totalOrder: Math.floor(n(totalOrder))});
                                                                }}
                                                                sx={{
                                                                    ...(this.state.open && {display: "none"}),
                                                                    width: 48,
                                                                    height: 48,
                                                                }}
                                                                size="large"
                                                            >
                                                                <RemoveCircleOutlineIcon
                                                                    sx={{fontSize: 32, color: "red"}}
                                                                />
                                                            </IconButton>

                                                            {/* Input */}
                                                            <input
                                                                type="text"
                                                                value={row.count}
                                                                style={{
                                                                    width: 100,
                                                                    direction: "rtl",
                                                                    textAlign: "right",
                                                                    padding: 6,
                                                                    borderRadius: 8,
                                                                    border: "1px solid #ccc",
                                                                    fontSize: 14,
                                                                }}
                                                                onChange={(e) => {
                                                                    let val = e.target.value;
                                                                    if (!/^\d*\.?\d*$/.test(val)) return;

                                                                    // int/float rules based on unit cache
                                                                    if (dataType === "int" && val.includes(".")) {
                                                                        val = val.split(".")[0];
                                                                    }

                                                                    if (dataType === "float") {
                                                                        if (val.includes(".")) {
                                                                            const [intPart, decPart] = val.split(".");
                                                                            if ((decPart || "").length > 3) return;
                                                                        }
                                                                        row.count = val;
                                                                        this.setState({});
                                                                        return;
                                                                    }

                                                                    if (val === "" || val === ".") {
                                                                        row.count = val;
                                                                        this.setState({});
                                                                        return;
                                                                    }

                                                                    let numVal = parseFloat(val);
                                                                    if (isNaN(numVal) || numVal < 0) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "تعداد معتبر وارد کنید!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        return;
                                                                    }

                                                                    const maxVal = n(row.product.step);
                                                                    if (numVal > maxVal) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا کافی نیست!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        numVal = maxVal;
                                                                    }

                                                                    if (dataType === "float") {
                                                                        numVal = parseFloat(numVal.toFixed(3));
                                                                    }

                                                                    row.count = numVal;
                                                                    this.setState({});

                                                                    CardShopRepository.updateCountByKey(key, row.product, numVal);

                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({totalOrder: Math.floor(n(totalOrder))});
                                                                }}
                                                                onBlur={() => {
                                                                    if (row.count === "" || row.count === ".") return;

                                                                    let val = parseFloat(row.count);
                                                                    if (isNaN(val) || val < 0) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "تعداد معتبر وارد کنید!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        row.count = "";
                                                                        return;
                                                                    }

                                                                    if (dataType === "int") {
                                                                        val = Math.floor(val);
                                                                    }
                                                                    if (dataType === "float") {
                                                                        val = parseFloat(val.toFixed(3));
                                                                    }

                                                                    const maxVal = n(row.product.step);
                                                                    if (val > maxVal) {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا کافی نیست!",
                                                                            snackbarType: "error",
                                                                        });
                                                                        val = maxVal;
                                                                    }

                                                                    row.count = val;
                                                                    this.setState({});

                                                                    CardShopRepository.updateCountByKey(key, row.product, val);

                                                                    const totalOrder = this.state.cardShopList.reduce(
                                                                        (sumMarket, m) => {
                                                                            const mt = (m.productList || []).reduce(
                                                                                (sumProduct, p) => {
                                                                                    const pr =
                                                                                        n(p?.product?.price) -
                                                                                        n(p?.product?.del_price);
                                                                                    const q = n(p?.count);
                                                                                    const lt = safeMultiply(
                                                                                        q,
                                                                                        pr > 0 ? pr : 0,
                                                                                        6
                                                                                    );
                                                                                    return safeAdd(sumProduct, lt, 6);
                                                                                },
                                                                                0
                                                                            );
                                                                            return safeAdd(sumMarket, mt, 6);
                                                                        },
                                                                        0
                                                                    );

                                                                    this.setState({totalOrder: Math.floor(n(totalOrder))});

                                                                    if (val === 0) {
                                                                        setTimeout(() => {
                                                                            CardShopRepository.removeItemByKey(key);
                                                                            this.getCardShop();
                                                                        }, 100);
                                                                    }
                                                                }}
                                                            />

                                                            {/* Increase */}
                                                            <IconButton
                                                                color="inherit"
                                                                aria-label="increase"
                                                                edge="end"
                                                                onClick={() => {
                                                                    let currentCount = n(row.count);
                                                                    const maxCount = n(row.product.step);

                                                                    if (currentCount < maxCount) {
                                                                        if (n(row.product.price) > 0) {
                                                                            currentCount = parseFloat(
                                                                                (currentCount + 1).toFixed(3)
                                                                            );
                                                                            if (currentCount > maxCount)
                                                                                currentCount = maxCount;

                                                                            CardShopRepository.updateCountByKey(
                                                                                key,
                                                                                row.product,
                                                                                currentCount
                                                                            );
                                                                            row.count = currentCount;

                                                                            const totalOrder = this.state.cardShopList.reduce(
                                                                                (sumMarket, m) => {
                                                                                    const mt = (m.productList || []).reduce(
                                                                                        (sumProduct, p) => {
                                                                                            const pr =
                                                                                                n(p?.product?.price) -
                                                                                                n(p?.product?.del_price);
                                                                                            const q = n(p?.count);
                                                                                            const lt = safeMultiply(
                                                                                                q,
                                                                                                pr > 0 ? pr : 0,
                                                                                                6
                                                                                            );
                                                                                            return safeAdd(sumProduct, lt, 6);
                                                                                        },
                                                                                        0
                                                                                    );
                                                                                    return safeAdd(sumMarket, mt, 6);
                                                                                },
                                                                                0
                                                                            );

                                                                            this.setState({
                                                                                totalOrder: Math.floor(n(totalOrder)),
                                                                            });
                                                                        } else {
                                                                            this.setState({
                                                                                openSnackbar: true,
                                                                                message: "جهت خرید کالا تماس بگیرید.",
                                                                                snackbarType: "error",
                                                                            });
                                                                        }
                                                                    } else {
                                                                        this.setState({
                                                                            openSnackbar: true,
                                                                            message: "موجودی کالا به اتمام رسیده!",
                                                                            snackbarType: "error",
                                                                        });
                                                                    }
                                                                }}
                                                                size="large"
                                                            >
                                                                <AddCircleIcon
                                                                    sx={{fontSize: 32, color: "green"}}
                                                                />
                                                            </IconButton>
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })}

                                            {/* Market total footer */}
                                            <Grid xs={12} style={{width: "100%", background: "green"}}>
                                                <p
                                                    style={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        paddingRight: 12,
                                                        fontSize: 12,
                                                        color: "white",
                                                    }}
                                                    align="right"
                                                >
                                                    {"مجموع: " +
                                                        priceTextFa(Math.floor(n(marketBucket.total))) +
                                                        " تومان"}
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </ListItemText>
                                </Paper>
                            </div>
                        </ListItem>
                    ))}
                </List>

                {this.state.cardShopList.length > 0 ? (
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            direction: "rtl",
                            paddingBottom: 90,
                        }}
                    >
                        <div style={{
                            marginTop: "15px",
                            display: "flex",
                            gap: "15px", // slightly increased gap for breathing room
                            flexWrap: "wrap",
                            justifyContent: "center"
                        }}>
                            {this.state.posDevices?.length ? (
                                this.state.posDevices.map((device, index) => (
                                    <Button
                                        key={index}
                                        onClick={() => this.sendToPos(device.full_ip)}
                                        variant="contained"
                                        startIcon={<PointOfSaleIcon style={{ marginLeft: 8, marginRight: -4 }} />}
                                        sx={{
                                            background: "linear-gradient(45deg, #059669 30%, #10b981 90%)", // Modern emerald green
                                            color: "white",
                                            padding: "10px 32px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            borderRadius: "14px",
                                            fontFamily: "inherit",
                                            boxShadow: "0 4px 14px 0 rgba(16, 185, 129, 0.39)",
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 20px 0 rgba(16, 185, 129, 0.5)",
                                            }
                                        }}
                                    >
                                        {`ارسال به ${device.pos_model_name || "پوز"}`}
                                    </Button>
                                ))
                            ) : (
                                <Tooltip
                                    title="⚠️ فیلترشکن خود را قبل از اتصال به درگاه خاموش کنید."
                                    placement="bottom"
                                    arrow
                                    open={true}
                                    TransitionComponent={Zoom2}
                                >
                                    <Button
                                        onClick={() => onPaymentCLicked()}
                                        variant="contained"
                                        startIcon={<CreditCardIcon style={{ marginLeft: 8, marginRight: -4 }} />}
                                        sx={{
                                            margin: "40px 0 10px 0",
                                            background: "linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)", // Modern vivid blue
                                            color: "white",
                                            padding: "12px 36px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            borderRadius: "14px",
                                            fontFamily: "inherit",
                                            boxShadow: "0 4px 14px 0 rgba(59, 130, 246, 0.39)",
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 6px 20px 0 rgba(59, 130, 246, 0.5)",
                                            }
                                        }}
                                    >
                                        {`پرداخت از طریق درگاه (${priceTextFa(Math.floor(
                                            n(this.state.totalOrder) +
                                            this.state.cardShopList.reduce(
                                                (sum) => sum /* + shipping */,
                                                0
                                            )
                                        ))} تومان)`}
                                    </Button>
                                </Tooltip>
                            )}
                        </div>

                        {/* --- Existing Online Gateway Button --- */}


                    </div>
                ) : null}



                <Snackbar
                    open={this.state.openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert
                        onClose={handleCloseSnackbar}
                        severity={this.state.snackbarType}
                        sx={{width: "100%"}}
                    >
                        {this.state.message}
                    </Alert>
                </Snackbar>

                {!this.props.table_id && <BottomMenu/>}

            </React.Fragment>
        );
    }
}